import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { offer } from '../data/offer';
import { CHECKOUT_LABEL, CTA_LABEL, OFFER_ANCHOR, PENDING_CHECKOUT_LABEL, isCheckoutReady } from '../utils/checkout';
interface CTAButtonProps {
  className?: string;
  /** 'offer' scrolls to the offer section, 'checkout' goes to the checkout once it is confirmed. */
  target?: 'offer' | 'checkout';
}
const BASE = 'inline-flex min-h-[56px] items-center justify-center gap-2 rounded-full px-8 py-4 text-center text-sm font-extrabold tracking-wide md:text-base';
const ACTIVE = 'bg-brand-gold text-brand-navy shadow-md transition-[background-color,box-shadow] duration-200 ease-out hover:bg-brand-gold-light hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-navy focus-visible:ring-offset-2';
export function CTAButton({
  className = '',
  target = 'offer'
}: CTAButtonProps) {
  if (target === 'checkout') {
    if (!isCheckoutReady() || !offer.checkoutUrl) {
      return <button type="button" disabled className={`${BASE} cursor-not-allowed bg-brand-sand text-brand-navy ring-1 ring-inset ring-brand-line ${className}`} data-id="element-66" data-mp="199y4o3cojeyg">
          {PENDING_CHECKOUT_LABEL}
        </button>;
    }
    return <a href={offer.checkoutUrl} className={`cta-attention inline-flex min-h-[60px] items-center justify-center gap-2 whitespace-nowrap rounded-full bg-brand-gold px-4 py-4 text-center text-[15px] font-extrabold text-brand-navy shadow-lg shadow-brand-gold/30 transition-[background-color,box-shadow] duration-200 ease-out hover:bg-brand-gold-light hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-navy sm:px-8 sm:text-lg sm:tracking-wide focus-visible:ring-offset-2 ${className}`} data-id="element-67" data-mp="1n8e91nn2ktdf">
        {CHECKOUT_LABEL}
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-68" data-mp="2awfe2ml1hro3" />
      </a>;
  }
  return <a href={OFFER_ANCHOR} className={`cta-attention ${BASE} ${ACTIVE} ${className}`} data-id="element-69" data-mp="2fuz00mzmv3gg">
      {CTA_LABEL}
      <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-70" data-mp="1la4mzdddslj5" />
    </a>;
}